import common from "../../common";
import QuestionView from "./QuestionView";

export default class QuestionViewSequence extends QuestionView {
    constructor(question) {
        super(question);
        this._confirmButton.x = this._footer.x + 400;

        this._minimumFontSize = this.calculateFontSize(this._question.values);

        this.createSeries();
    }

    getHeaderText() {
        const data = P3.assets.json("templates");
        const name = data.template ? data.template : this._question.module;
       // let templates = data["templates"][name][this._question.type];

        const split = this._question.template.split("/");
        let templates = data.templates[split[0]][split[1]];

        if (templates) {
            templates = templates.slice().filter(x => this.filterTemplate(x));
        }

        if (!templates || !templates.length) return "ERROR: NO TEMPLATE FOUND";

        this._template = P3.utils.selectRandom(templates);

        return this._template.text;
    }

    createSeries(spacing = 16) {
        let width = 0;

        const labelContainer = new PIXI.Container();
        this._footer.addChild(labelContainer);

        for (let i = 0; i < this._question.values.length; ++i) {
            const value = this._question.values[i];

            if (i !== this._question.part) {
                const label = this.createLabel(value.toString());
                label.position.set(width, 0);
                labelContainer.addChild(label);

                width += label.textWidth + spacing;
                (i < this._question.values.length - 1) && (width += spacing);
            } else {
                width += this._inputField.width * 0.5;

                this._inputField.position.set(width, 0);
                labelContainer.addChild(this._inputField);

                width += this._inputField.width * 0.5;
                i < this._question.values.length - 1 && (width += spacing);
            }
        }

        // center statement
        labelContainer.pivot.x = width * 0.5;
    }

    createLabel(text) {
        const label = new PIXI.extras.BitmapText(text, {
            font: {name: "BBC Reith Sans Math Large", size: this._minimumFontSize}, tint: 0x0});
        label.anchor.set(0, 0.5);
        this._footer.addChild(label);
        return label;
    }

    calculateFontSize(values) {
        const size = 48;

        for (let i = 0; i < values.length; ++i) {
            const value = values[i];
            const str = value.toString();
            if (str.length >= 7) {
                return 36;
            } else if (str.length >= 5) {
                return 40;
            }
        }
        return size;
    }
}